import { render, staticRenderFns } from "./SaveAllAsCandidatesProcessing.vue?vue&type=template&id=5396b865&scoped=true&"
import script from "./SaveAllAsCandidatesProcessing.vue?vue&type=script&lang=js&"
export * from "./SaveAllAsCandidatesProcessing.vue?vue&type=script&lang=js&"
import style0 from "./SaveAllAsCandidatesProcessing.vue?vue&type=style&index=0&id=5396b865&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5396b865",
  null
  
)

export default component.exports